"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaOfUtilsForUser = exports.utilsForUser = void 0;
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
const ajv_1 = tslib_1.__importDefault(require("ajv"));
const package_json_1 = require("ajv/package.json");
const js_yaml_1 = require("js-yaml");
const xml_js_1 = require("xml-js");
const lodash_1 = tslib_1.__importStar(require("lodash"));
const package_json_2 = require("lodash/package.json");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const package_json_3 = require("dayjs/package.json");
const nanoid_1 = require("nanoid");
const nanoid_dictionary_1 = tslib_1.__importDefault(require("nanoid-dictionary"));
const axios_1 = tslib_1.__importDefault(require("axios"));
const package_json_4 = require("axios/package.json");
const buffer_1 = require("buffer");
const package_json_5 = require("buffer/package.json");
const crypto = tslib_1.__importStar(require("crypto-js"));
const package_json_6 = require("crypto-js/package.json");
const qs = tslib_1.__importStar(require("querystring"));
const package_json_7 = require("querystring/package.json");
const wujiFilter_1 = require("./wujiFilter");
const json_bigint_1 = tslib_1.__importDefault(require("json-bigint"));
const package_json_8 = require("json-bigint/package.json");
// 注册 dayjs 的插件
const customParseFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/customParseFormat"));
const utc_1 = tslib_1.__importDefault(require("dayjs/plugin/utc"));
const duration_1 = tslib_1.__importDefault(require("dayjs/plugin/duration"));
const holidays_1 = require("./holidays");
dayjs_1.default.extend(customParseFormat_1.default);
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(duration_1.default);
const wholeSchema = {
    id: '$utils',
    title: '工具方法',
    hidden: true,
    type: 'object',
    fields: [],
    methods: [],
};
const method = (schema) => (_, id) => {
    wholeSchema.methods.push(Object.assign(Object.assign({}, schema), { id }));
};
const variable = (schema) => (_, id) => {
    wholeSchema.fields.push(Object.assign(Object.assign({}, schema), { id }));
};
const isUndefined = val => val === undefined;
const isUndefinedOrEmptyStr = val => val === undefined || val === '';
const cryptoEncTsType = '"base64" | "latin1" | "utf8" | "utf-8" | "hex" | "raw"';
const getCryptoEnc = (type) => {
    switch (String(type).toLowerCase()) {
        case 'base64':
            return crypto.enc.Base64;
        case 'raw':
        case 'latin1':
            return crypto.enc.Latin1;
        case 'utf8':
        case 'utf-8':
            return crypto.enc.Utf8;
        case 'hex':
        default:
            return crypto.enc.Hex;
    }
};
const holidayCheck = (collection, input) => {
    var _a;
    if (!input)
        return false;
    if (typeof input === 'number' || input instanceof Date)
        input = (0, dayjs_1.default)(input).format('YYYY-MM-DD');
    if (typeof input !== 'string')
        return false;
    const year = input.slice(0, 4);
    const remain = input.slice(5, 10);
    return !!((_a = collection[year]) === null || _a === void 0 ? void 0 : _a.includes(remain));
};
class UtilsForUser {
    constructor() {
        this.lodash = lodash_1.default;
        this.ajv = ajv_1.default;
        this.axios = axios_1.default;
        this.dayjs = dayjs_1.default;
        this.JSONBigInt = json_bigint_1.default;
        this.crypto = crypto;
        this.Buffer = buffer_1.Buffer;
        this.qs = qs;
        this.orderBy = lodash_1.orderBy;
        this.filterData = wujiFilter_1.wujiFilter;
        this.randomIdDictionary = nanoid_dictionary_1.default;
        try {
            wholeSchema.methods.forEach((item) => {
                const { id } = item;
                if (typeof id !== 'string'
                    || typeof this[id] !== 'function'
                    || Object.prototype.hasOwnProperty.call(this, id)) {
                    return;
                }
                this[id] = this[id].bind(this); // 让$utils的原型方法 可以再 obj={...$utils} 生效
            });
        }
        catch (error) {
            console.error(error);
        }
    }
    formatDate(value, format) {
        if (value === undefined || Number.isNaN(value))
            value = Date.now() / 1000;
        return (0, dayjs_1.default)(value * 1000).format(format || 'YYYY-MM-DD HH:mm:ss');
    }
    isWorkday(date) {
        return !holidayCheck(holidays_1.holidays, date);
    }
    validateJSONSchema(schema, data) {
        if (!schema)
            return { valid: true, errors: [] };
        const validate = (0, ajv_1.default)().compile(schema);
        const valid = validate(data);
        return { valid, errors: validate.errors };
    }
    md5(value, outputFormat) {
        return crypto.MD5(value).toString(getCryptoEnc(outputFormat));
    }
    sha256(value, outputFormat) {
        return crypto.SHA256(value).toString(getCryptoEnc(outputFormat));
    }
    sha1(value, outputFormat) {
        return crypto.SHA1(value).toString(getCryptoEnc(outputFormat));
    }
    base64_encode(value) {
        return buffer_1.Buffer.from(value).toString('base64');
    }
    base64_decode(value) {
        return buffer_1.Buffer.from(value, 'base64').toString('utf8');
    }
    cloneDeep(x) {
        return (0, lodash_1.cloneDeep)(x);
    }
    forEach(source, callback) {
        return (0, lodash_1.forEach)(source, callback);
    }
    isEqual(a, b) {
        return (0, lodash_1.isEqual)(a, b);
    }
    mapValues(source, mapper) {
        if (Array.isArray(source))
            return source.map(mapper);
        return (0, lodash_1.mapValues)(source, mapper);
    }
    pick(source, filter) {
        return (0, lodash_1.pickBy)(source, getSafeFilter(filter));
    }
    omit(source, filter) {
        return (0, lodash_1.omitBy)(source, getSafeFilter(filter));
    }
    fromPairs(x) {
        return (0, lodash_1.fromPairs)(x);
    }
    toPairs(x) {
        return (0, lodash_1.toPairs)(x);
    }
    get(o, path) {
        if ((!path && path !== 0) || (Array.isArray(path) && path.length === 0))
            return o;
        return (0, lodash_1.get)(o, path);
    }
    /**
     * lodash 里面只支持对象，值类型必须写判断表达式，比较麻烦
     */
    remove(array, target) {
        const index = array.indexOf(target);
        if (index >= 0) {
            array.splice(index, 1);
            return true;
        }
        return false;
    }
    parseYaml(yamlString) {
        return (0, js_yaml_1.load)(yamlString);
    }
    parseXml(xmlString, opts = { compact: true }) {
        return (0, xml_js_1.xml2json)(xmlString, opts);
    }
    toYaml(value) {
        return (0, js_yaml_1.dump)(value);
    }
    getRandomId(size, alphabet) {
        const NANOID_ALPHABET = `${nanoid_dictionary_1.default.numbers}${nanoid_dictionary_1.default.lowercase}`;
        return (0, nanoid_1.customAlphabet)(alphabet || NANOID_ALPHABET, size || 16)();
    }
    translateFilterToStr(filterStr) {
        // 兼容1.0语法：如果第一位不是数组开头，则视为1.0语法透传
        let filter = [];
        if (typeof filterStr === 'string') {
            if (filterStr[0] !== '[') {
                return filterStr;
            }
            try {
                filter = JSON.parse(filterStr);
            }
            catch (e) {
                throw new Error(`Filter parsing failed: ${e.message}`);
            }
        }
        else {
            // 认为是 KOV
            filter = filterStr;
        }
        if (typeof filter.length !== 'number') {
            throw new Error('Filter parsing failed: filter is not array');
        }
        ;
        const formattedFilter = filter
            .filter(({ k, o, v }) => !isUndefined(k) && !isUndefined(o) && !isUndefined(v))
            .map(({ k, o, v }) => {
            if (typeof v === 'string') {
                return `${k}${o}"${v}"`;
            }
            const trueType = Object.prototype.toString.call(v);
            if (/object array/i.test(trueType)) {
                return `${k}${o}${JSON.stringify(v)}`;
            }
            // 如果 v 是对象，那么把对象打扁, 只解析一层，默认 v 的结构是 {key: string | array}
            if (/object object/i.test(trueType)) {
                return Object.keys(v)
                    .filter(keyOfV => !isUndefinedOrEmptyStr(v[keyOfV]))
                    .map(keyOfV => `${k}.${keyOfV}${o}${JSON.stringify(v[keyOfV])}`)
                    .join('&');
            }
            return `${k}${o}${v}`;
        })
            .join('&');
        if (!formattedFilter)
            return '';
        return formattedFilter;
    }
    ;
}
tslib_1.__decorate([
    method({
        title: '格式化日期',
        returnValue: { type: 'string' },
        arguments: [
            {
                id: 'timestampSec',
                type: 'number',
                title: '时间(Unix秒)',
            },
            {
                id: 'format',
                type: 'string',
                title: '格式',
                default: '"YYYY-MM-DD HH:mm:ss"',
                description: '参考dayjs的格式，例如 "YYYY-MM-DD HH:mm:ss"',
            },
        ],
    })
], UtilsForUser.prototype, "formatDate", null);
tslib_1.__decorate([
    method({
        title: '判断是否是工作日',
        description: `注意！数据仅供参考，如果有严谨需求和自己的日历，请不要依赖此接口。\n\n数据范围：${holidays_1.minYear} - ${holidays_1.maxYear}，以中国大陆为准，参考了调休补班信息`,
        returnValue: { type: 'boolean' },
        arguments: [
            {
                id: 'date',
                type: 'string',
                required: true,
                title: '日期',
                description: '时间字符串（开头是2023-01-23这种）或者 UNIX 毫秒',
            },
        ],
    })
], UtilsForUser.prototype, "isWorkday", null);
tslib_1.__decorate([
    variable({
        title: `lodash v${package_json_2.version}`,
        tsType: 'typeof import(\'lodash\')',
    })
], UtilsForUser.prototype, "lodash", void 0);
tslib_1.__decorate([
    variable({
        title: `ajv v${package_json_1.version}`,
        description: '备注：如果只是想简单校验，可以使用 `validateJSONSchema` 方法。',
        tsType: 'typeof import(\'ajv\')',
    })
], UtilsForUser.prototype, "ajv", void 0);
tslib_1.__decorate([
    method({
        title: '校验 JSON Schema',
        description: '使用 JSON Schema 校验数据，返回 `{ valid: boolean, errors: Error[] }` 对象。\n\n如果有高级需求，可以使用 `ajv` 自行实现。',
        arguments: [
            { id: 'schema', type: 'object', required: true },
            { id: 'data', type: 'object', required: true },
        ],
        returnValue: {
            type: 'object',
            title: '校验结果报告',
            fields: [
                { id: 'valid', type: 'boolean', description: '是否校验通过' },
                { id: 'errors', type: 'array', items: { type: 'object', tsType: 'Error' } },
            ],
        },
    })
], UtilsForUser.prototype, "validateJSONSchema", null);
tslib_1.__decorate([
    variable({
        title: `axios v${package_json_4.version}`,
        tsType: 'typeof import(\'axios\').AxiosStatic',
    })
], UtilsForUser.prototype, "axios", void 0);
tslib_1.__decorate([
    variable({
        title: `dayjs v${package_json_3.version}`,
        tsType: 'typeof import(\'dayjs\')',
    })
], UtilsForUser.prototype, "dayjs", void 0);
tslib_1.__decorate([
    variable({
        title: `json-bigint v${package_json_8.version}`,
    })
], UtilsForUser.prototype, "JSONBigInt", void 0);
tslib_1.__decorate([
    variable({
        title: `crypto-js v${package_json_6.version}`,
        tsType: 'typeof import(\'crypto-js\')',
    })
], UtilsForUser.prototype, "crypto", void 0);
tslib_1.__decorate([
    variable({
        title: `buffer v${package_json_5.version}`,
        tsType: 'typeof import(\'buffer\').Buffer',
    })
], UtilsForUser.prototype, "Buffer", void 0);
tslib_1.__decorate([
    variable({
        title: `querystring v${package_json_7.version}`,
        type: 'object',
        methods: [
            { id: 'parse', arguments: [{ id: 'str', type: 'string', required: true }] },
            { id: 'stringify', arguments: [{ id: 'obj', type: 'object', required: true }], returnValue: { type: 'string' } },
            { id: 'escape', arguments: [{ id: 'str', type: 'string', required: true }] },
            { id: 'unescape', arguments: [{ id: 'str', type: 'string', required: true }] },
        ],
    })
], UtilsForUser.prototype, "qs", void 0);
tslib_1.__decorate([
    method({
        arguments: [
            { id: 'value', required: true },
            {
                id: 'outputFormat',
                description: '输出格式，例如 base64、hex、latin1 等',
                tsType: cryptoEncTsType,
            },
        ],
        returnValue: { type: 'string' },
    })
], UtilsForUser.prototype, "md5", null);
tslib_1.__decorate([
    method({
        arguments: [
            { id: 'value', required: true },
            {
                id: 'outputFormat',
                description: '输出格式，例如 base64、hex、latin1 等',
                tsType: cryptoEncTsType,
            },
        ],
        returnValue: { type: 'string' },
    })
], UtilsForUser.prototype, "sha256", null);
tslib_1.__decorate([
    method({
        arguments: [
            { id: 'value', required: true },
            {
                id: 'outputFormat',
                description: '输出格式，例如 base64、hex、latin1 等',
                tsType: cryptoEncTsType,
            },
        ],
        returnValue: { type: 'string' },
    })
], UtilsForUser.prototype, "sha1", null);
tslib_1.__decorate([
    method({
        arguments: [{ id: 'value', required: true }],
        returnValue: { type: 'string' },
    })
], UtilsForUser.prototype, "base64_encode", null);
tslib_1.__decorate([
    method({
        arguments: [{ id: 'value', required: true }],
        returnValue: { type: 'string' },
    })
], UtilsForUser.prototype, "base64_decode", null);
tslib_1.__decorate([
    method({
        description: '深层 clone 一个对象或数组',
        arguments: [{ id: 'value' }],
        tsType: '<T>(value: T) => T',
    })
], UtilsForUser.prototype, "cloneDeep", null);
tslib_1.__decorate([
    method({
        description: '遍历一个对象或数组',
        arguments: [
            {
                id: 'source',
                description: '要遍历的东西，可以是对象/数组',
            },
            {
                id: 'callback',
                description: '遍历的回调方法，例如 `(value, key) => { ... }`',
            },
        ],
        tsType: 'typeof import("lodash").forEach',
    })
], UtilsForUser.prototype, "forEach", null);
tslib_1.__decorate([
    method({
        description: '深层比较两个对象/数组，看是否相同',
        arguments: [{ id: 'a' }, { id: 'b' }],
        returnValue: { type: 'boolean' },
    })
], UtilsForUser.prototype, "isEqual", null);
tslib_1.__decorate([
    method({
        description: '根据规则，逐个转换数组/对象的值，返回新数组/对象',
        arguments: [
            { id: 'source', description: '原始对象' },
            {
                id: 'mapper',
                description: '一个 `(value, key, context) => any` 的回调方法',
            },
        ],
        tsType: 'typeof import("lodash").mapValues',
    })
], UtilsForUser.prototype, "mapValues", null);
tslib_1.__decorate([
    method({
        description: '抽取一些字段，组成新的对象并返回',
        arguments: [
            { id: 'source', description: '原始对象' },
            {
                id: 'filter',
                description: '要保留哪些字段，可以是 一个数组，或者 `(value, key) => boolean` 的回调方法',
            },
        ],
    })
], UtilsForUser.prototype, "pick", null);
tslib_1.__decorate([
    method({
        description: '排除一些字段，组成新的对象并返回',
        arguments: [
            { id: 'source', description: '原始对象' },
            {
                id: 'filter',
                description: '要排除哪些字段，可以是 一个数组，或者 `(value, key) => boolean` 的回调方法',
            },
        ],
    })
], UtilsForUser.prototype, "omit", null);
tslib_1.__decorate([
    method({
        description: '从形如 `[ [key, value], [key2, value2] ]` 的数组，生成 `{ key: value, key2: value2 }` 这样的对象',
        arguments: [{ id: 'pairs' }],
        tsType: 'typeof import("lodash").fromPairs',
    })
], UtilsForUser.prototype, "fromPairs", null);
tslib_1.__decorate([
    method({
        description: '从 `{ key: value, key2: value2 }` 这样的对象，生成形如 `[ [key, value], [key2, value2] ]` 的数组',
        arguments: [{ id: 'object' }],
        tsType: 'typeof import("lodash").toPairs',
    })
], UtilsForUser.prototype, "toPairs", null);
tslib_1.__decorate([
    method({
        description: '从一个对象里获取一个数据',
        arguments: [
            { id: 'object' },
            {
                id: 'path',
                description: '路径，可为一个数组，或者 `foo.bar[2]` 这种字符串',
            },
        ],
    })
], UtilsForUser.prototype, "get", null);
tslib_1.__decorate([
    method({
        description: '从一个数组里删除一个数据项',
        arguments: [
            { id: 'array', type: 'array', required: true },
            {
                id: 'target',
                required: true,
                description: '删除项',
            },
        ],
    })
    /**
     * lodash 里面只支持对象，值类型必须写判断表达式，比较麻烦
     */
], UtilsForUser.prototype, "remove", null);
tslib_1.__decorate([
    method({
        description: '解析YAML(字符串)成JSON对象',
        arguments: [{ id: 'yamlString', type: 'string', required: true }],
        returnValue: { type: 'object' },
    })
], UtilsForUser.prototype, "parseYaml", null);
tslib_1.__decorate([
    method({
        description: '解析XML(字符串）成JSON字符串',
        arguments: [
            { id: 'xmlString', type: 'string', required: true },
            { id: 'opts', description: '对应xml-js的xml2json方法的第二个参数' },
        ],
        returnValue: { type: 'string' },
    })
], UtilsForUser.prototype, "parseXml", null);
tslib_1.__decorate([
    method({
        description: '将对象/数组转换为YAML字符串',
        arguments: [{ id: 'value', type: 'object', required: true }],
        returnValue: { type: 'string' },
    })
], UtilsForUser.prototype, "toYaml", null);
tslib_1.__decorate([
    method({
        description: `数组排序 
    $utils.orderBy(users, ['user', 'age'], ['asc', 'desc']); //以 user 升序排序 再  age 以降序排序`,
        arguments: [{ id: 'array' }, { id: 'keys' }, { id: 'orders' }],
        tsType: 'typeof import("lodash").orderBy',
    })
], UtilsForUser.prototype, "orderBy", void 0);
tslib_1.__decorate([
    method({
        description: '根据标准的wuji filter进行本地过滤',
        arguments: [
            { id: 'array' },
            { id: 'filter' },
            {
                id: 'options', type: 'array', items: {
                    type: 'object',
                    fields: [
                        { id: 'type', description: '"and" | "or"' },
                        { id: 'caseSensitive', description: '是否区分大小写，默认为true' },
                    ],
                },
            },
        ],
    })
], UtilsForUser.prototype, "filterData", void 0);
tslib_1.__decorate([
    method({
        description: '基于nanoid的随机ID生成函数。支持以下两种调用：getRandomId(size, alphabet)、getRandomId(size)',
        arguments: [
            {
                id: 'size',
                type: 'number',
                description: '可选。随机id的长度，默认16',
            },
            {
                id: 'alphabet',
                type: 'string',
                description: '可选。构成因子，默认取数字和小写字母。更多字典可选$utils.randomIdDictionary',
                required: false,
            },
        ],
        returnValue: { type: 'string' },
    })
], UtilsForUser.prototype, "getRandomId", null);
tslib_1.__decorate([
    method({
        description: '把 kov 格式的 filter 转化成字符串格式。',
        arguments: [
            {
                id: 'filterStr',
                type: 'string',
                description: 'JSON序列化后的 filter，如 \'[{"k":"name","o":"=","v":"wuji"}]\'',
                required: true,
            },
        ],
    })
], UtilsForUser.prototype, "translateFilterToStr", null);
tslib_1.__decorate([
    variable({
        title: 'randomIdDictionary',
        description: '随机ID构成因子，详情请参考nanoid-dictionary。可取值： \'numbers\', \'lowercase\', \'uppercase\', \'alphanumeric\' 等',
        type: 'object',
        fields: [
            { id: 'numbers', type: 'string', title: '数字' },
            { id: 'hexadecimalLowercase', type: 'string', title: '十六进制(小写字母)' },
            { id: 'hexadecimalUppercase', type: 'string', description: '十六进制(大写字母)' },
            { id: 'lowercase', type: 'string', title: '小写字母' },
            { id: 'uppercase', type: 'string', title: '大写字母' },
            { id: 'alphanumeric', type: 'string', title: '数字+大小写字母' },
            { id: 'nolookalikes', type: 'string', title: '数字+大小写字母(排除相似字符)' }, ,
            { id: 'nolookalikesSafe', type: 'string', title: '数字+大小写字母(排除相似字符)' },
        ],
    })
], UtilsForUser.prototype, "randomIdDictionary", void 0);
const getSafeFilter = (f) => {
    if (!f)
        return () => false;
    if (Array.isArray(f))
        return (_, k) => f.includes(k);
    if (typeof f === 'function')
        return f;
    f = String(f);
    return (_, k) => String(k) === f;
};
exports.utilsForUser = Object.seal(new UtilsForUser());
exports.schemaOfUtilsForUser = Object.seal(wholeSchema);
